import { Avatar } from '@mui/material'
import ButtonCustom from '../../atoms/button/ButtonCustom'
import styles from './index.module.scss'

const cardStatusMap = {
	Completed: 'completed',
	Charged: 'in-progress',
	Pending: 'pending',
}
export default function CardView(props) {
	const cardStatusClass = cardStatusMap[props.statusLabel] || ''
	return (
		<div className={styles.cardView}>
			{/* Header */}
			<div className={styles.cardHead}>
				<div className={styles.cardHeadLeft}>
					<figure className={styles.cardImage}>
						<Avatar src={props.image} alt={props.title} />
					</figure>
					<div className={styles.cardHeadText}>
						<h2>{props.title}</h2>
						<div className={styles.cardHeadTextSub}>
							<p>
								<img
									src="/images/calendar.svg"
									alt="Calendar"
								/>{' '}
								<span>{props.date}</span>
							</p>
						</div>
					</div>
				</div>
			</div>

			{/* Body */}
			<div className={styles.cardBodyMain}>
				<div className={styles.cardBody}>
					<span>Invoice: {props.invoice} </span>
				</div>

				{/* Footer */}
				<div className={styles.cardFooter}>
					<div className={styles.cardFooterBtn}>
						<ButtonCustom
							data-cy="viewdetail"
							variant="outlined"
							size="lg"
							onClick={props.onViewDetail}
						>
							View Detail
						</ButtonCustom>
					</div>
				</div>
			</div>

			{/* Status */}
			{props.statusLabel && (
				<div
					className={`${styles.cardStatus} ${
						styles[cardStatusClass]
					}`}
				>
					<p>{props.statusLabel}</p>
				</div>
			)}
		</div>
	)
}
